import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ONBOARDING_PATH, ROOT_PATH } from "../../../../routes/constants";
import { createCandidateFunc } from "./create-candidate";
import { useDispatch } from "react-redux";
import { loginAsync } from "../../../auth/redux/auth-slice";
import { OtpContextEnum, UserTypeEnum } from "../../../common/network/enum";
import { getI18n, useTranslation } from "react-i18next";
import {
  TakeUIClickEventParameters,
  TakeUIScreenViewEventParameters,
} from "../../../../common/ga/types/ga-general-type";
import { takeUIClickEvent, takeUIScreenViewEvent } from "../../../../common/ga/ga";
//PHKL Custom -s
import { useQuery } from "../../../../utils/hooks/use-query";
import { setItem } from "../../../../utils/local-storage";
//PHKL Custom -e

export const useSetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  //PHKL Custom -s
  const query: any = useQuery();
  const invitationId = query.get("iid");
  const lang = query.get("lang");
  useEffect(() => {
    if (lang) {
      setItem("i18nextLng", lang.toLocaleLowerCase());
      i18n.changeLanguage(lang.toLocaleLowerCase());
    }
  }, [lang]);
  //PHKL Custom -e

  const user: any = useMemo(() => {
    return location.state?.user;
  }, [location.state?.user]);

  const [password, setPassword] = useState("");
  const [reEnterPassword, setReEnterPassword] = useState(""); //PHKL Custom
  const [reEnterErrorMessages, setReEnterErrorMessages] = useState<string>(""); //PHKL Custom
  const [errorMessages, setErrorMessages] = useState<string>("");
  //PHKL Custom -s
  const [isValid, setIsValid] = useState<boolean>(false);
  const [reEnterIsValid, setReEnterIsValid] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  useEffect(() => {
    if (!user) {
      navigate(`${ROOT_PATH}/login`);
    }
  }, []);

  useEffect(() => {
    setErrorMessages("");
    setReEnterErrorMessages("");
  }, [password, reEnterPassword]);
  //PHKL Custom -e

  // TODO: Move password validation to common utils
  const validatePassword = (password: string) => {
    return (
      password.length >= 8 &&
      password.length <= 15 &&
      /[0-9]/.test(password) &&
      /[a-z]/.test(password) &&
      /[A-Z]/.test(password)
    );
  };

  const onConfirm = async () => {
    const gaData: TakeUIClickEventParameters = {
      module: "Login",
      feature: "CandidateLogin",
      journey: "create_account",
      stage: "set_password",
      screen_id: "SCR_LGN_CNDDT_ST_PSSWRD",
      screen_name: "Login-Candidate-Set-Password-Screen",
      object_name: "Confirm",
      object_type: "BUTTON",
    };
    takeUIClickEvent(gaData);

    const acceptableChar = `^[a-zA-Z0-9!@#$%~*&^]+$`;
    if (!new RegExp(acceptableChar).test(password)) {
      setErrorMessages(t("Recruitment.set_password_symbol"));
      return;
    } else {
      if (!password || !validatePassword(password)) {
        return;
      }
      setErrorMessages("");
    }

    //PHKL Custom -s
    if (password != reEnterPassword) {
      setReEnterErrorMessages(t("Recruitment.onboarding_login_re_enter_password_msg"));
      return;
    }
    setIsSubmitted(true);
    //PHKL Custom -e

    const res = await createCandidateFunc({
      username: user?.phoneNum, //PHKL Custom
      password,
      context: user?.context,
      otp: user?.otp,
      lang: getI18n().language || "en", //PHKL Custom
      invitationId: invitationId, //PHKL Custom
      userId: user?.username, //PHKL Custom
    });
    if (!res.ok) {
      //PHKL Custom -s
      setTimeout(() => {
        setIsSubmitted(false);
      }, 3000);
      //PHKL Custom -e
      return;
    } else {
      //PHKL Custom -s
      const data = res?.data || res || {};
      // await dispatch<any>(
      //   loginAsync({
      //     username: user?.username,
      //     password,
      //     userType: UserTypeEnum.CANDIDATE,
      //   }),
      // );
      if (user?.context === OtpContextEnum.FIRST_LOGIN) {
        navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/edit-info`, {
          state: {
            params: {
              invitationId: invitationId,
              userName: user?.username || data.userId,
              password,
            },
          },
        });
      }
      //PHKL Custom -e
      else if (user?.context === OtpContextEnum.FORGOT_PASSWORD) {
        navigate(`${ROOT_PATH}/login`);
      } else {
        navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/join-now`, {
          state: { userName: user?.username },
        });
      }
    }
  };

  return {
    isForgotPassowrd: user?.context === OtpContextEnum.FORGOT_PASSWORD, //PHKL Custom
    password,
    setPassword,
    reEnterPassword, //PHKL Custom
    setReEnterPassword, //PHKL Custom
    onConfirm,
    errorMessages,
    reEnterErrorMessages, //PHKL Custom
    isValid, //PHKL Custom
    setIsValid, //PHKL Custom
    reEnterIsValid, //PHKL Custom
    setReEnterIsValid, //PHKL Custom
    isSubmitted, //PHKL Custom
  };
};
